import { hasPrivilege, PRIVILEGES } from '@thoughtspot/session-service';
export const hasModernFMPrivilege = () => hasPrivilege(PRIVILEGES.ADMINISTRATION) ||
    (hasPrivilege(PRIVILEGES.ORG_ADMINISTRATION) &&
        hasPrivilege(PRIVILEGES.APPLICATION_ADMINISTRATION));
//# sourceMappingURL=feature-management-privilege.js.map